import { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Pagination , { PagiSearch } from "../components/Pagination";
import { getApiSetting, postApiSetting, typeNumber } from "../assets/functions";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import { NavLink,useNavigate } from "react-router-dom";

export default function ProcessorManagement ({setAuth}) {

    const { register, handleSubmit, formState:{ errors } } = useForm();
 const navigate = useNavigate();
    const [transactinoData, setTransactinoData] = useState([]);
    const [startOffset, setStartOffset] = useState(0);
    const [search, setSearch] = useState('');
    const [tableDataStatus, setTableDataStatus] = useState('');
    const [refreshTable, setRefreshTable] = useState(false);

    const closeRef = useRef(null);

    const itemsPerPage = 10;
    const searchData = transactinoData.filter(item => Object.values(item).join("").toString().toLowerCase().includes(search.toLowerCase()))
    const endOffset = startOffset + itemsPerPage;
    const currentItems = searchData.slice(startOffset, endOffset)
    const pageCount = Math.ceil(searchData.length / itemsPerPage)

    useEffect(()=>{
        setTableDataStatus('Loading...');
        (async()=>{
            try {
                // let res = await fetch('/admin/api/Admin/Processor/fetchProcessorDetails', getApiSetting());
                let res = await fetch('/Admin/api/Admin/Processor/fetchProcessorDetails', getApiSetting());
                let result = (res.status === 200) ? await res.json(): "";
                console.log(res)
                console.log(result)
                if(res.status === 200){
                    if(result.data.responseData.length < 1){
                        setTableDataStatus('Not Found')
                    }else{
                        let data = result.data.responseData.sort(function(a, b) {
                            let c = new Date(a.creationDate);
                            let d = new Date(b.creationDate);
                            return d-c;
                        })
                        setTableDataStatus('')
                        setTransactinoData(data)
                        closeRef.current.click();
                    }
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) { console.log(error) }
        })()
    },[refreshTable])

    const submitProcForm = async (data) => {
        console.log(data)
        let settings = postApiSetting(data)
        try {
            // let res = await fetch('/admin/api/Admin/Processor/addProcessorDetails', settings);
            let res = await fetch('/Admin/api/Admin/Processor/addProcessorDetails', settings);
            let result = (res.status === 200) ? await res.json(): "";
            console.log(res)
            console.log(result)
            if(res.status !== 200){
               if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            }else{
                if(result.statusCode == 0){
                    alert('SUCCESS : '+result.status)   
                    setRefreshTable(refresh => !refresh)
                }else{
                    alert('FAILED : '+result.status)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const deleteProc = async (id) => {
        console.log(id)
        try {
            // let res = await fetch(`/admin/api/Admin/Processor/deleteProcessorDetails/${id}`, getApiSetting());
            let res = await fetch(`/Admin/api/Admin/Processor/deleteProcessorDetails/${id}`, getApiSetting());
            let result = (res.status === 200) ? await res.json(): "";
            // console.log(res)
            // console.log(result)
            if(res.status === 200){
                if(result.statusCode == 0){
                    alert(result.status)
                    setRefreshTable(refresh => !refresh)
                }else{
                    alert(result.status)
                }
            }
             else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
        } catch (error) {
            console.log(error)
        }
    }

    const editProc = (id) => {
        console.log(id)
    }

    return (<>
        {/* <SidebarNavigation /> */}
        <section className="transaction-page">
            <Navbar title="TRANSACTIONS" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">PROCESSOR MANAGEMENT</h6>
                    
                    <div className="text-end mb-3">
                        <button type="button" className="btn text-white _themebg-0" data-bs-toggle="modal" data-bs-target="#procModal">
                            <i className="fas fa-plus"></i>
                        </button>
                    </div>

                    <PagiSearch setSearch={setSearch}
                    totalEntries={searchData.length}
                    setStartOffset={setStartOffset}
                    setTableDataStatus={setTableDataStatus} />

                    <div className="table-responsive my-2 com-table">
                    <table className="table table-bordered mb-1">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Proc Name</th>
                                <th>Proc MID</th>
                                <th>Paymode</th>
                                <th>Paymode Category</th>
                                <th>Proc Credential 1</th>
                                <th>Proc Credential 2</th>
                                <th>Proc Credential 3</th>
                                <th>Proc Credential 4</th>
                                <th>Proc Credential 5</th>
                                <th>Proc URL</th>
                                <th>Creation Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length < 1 ? <tr><td colSpan={11}><h6>{tableDataStatus}</h6></td></tr> : 
                            currentItems.map((item,index) => {
                                return (
                                <tr key={index}>
                                    <td>{startOffset + index + 1}</td>
                                    <td>{item.procName}</td>
                                    <td>{item.procMid}</td>
                                    <td>{item.paymode}</td>
                                    <td>{item.paymodeCategory}</td>
                                    <td>{item.procCred_1}</td>
                                    <td>{item.procCred_2}</td>
                                    <td>{item.procCred_3}</td>
                                    <td>{item.procCred_4}</td>
                                    <td>{item.procCred_5}</td>
                                    <td>{item.procUrl}</td>
                                    <td>{item.creationDate}</td>
                                    <td>
                                        <button className="btn btn-sm text-success" onClick={()=>editProc(item.id)}><i className="fa-solid fa-pen-to-square"></i></button>
                                        <button className="btn btn-sm text-danger" onClick={()=>deleteProc(item.id)}><i className="fa-solid fa-trash-can"></i></button>
                                    </td>
                                </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    </div>

                    <Pagination setStartOffset={setStartOffset}
                    pageCount={pageCount} itemsPerPage={itemsPerPage} />

                </div>
            </div>
        </section>

        <div className="modal fade" id="procModal" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title ms-3" id="exampleModalLabel">ADD PROCESSOR</h5>
                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                </div>
                <div className="modal-body">
                    <form className="px-3 pb-2" onSubmit={handleSubmit(submitProcForm)}>
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Processor Name <strong className='text-danger'>*</strong></label>
                                <select className="form-select shadow-none" {...register('procName', 
                                { required : { value:true, message:"This field is required" } })} >
                                    <option value="">--Select--</option>
                                    <option value="SELFOFQR">SELFOFQR</option> 
                                    <option value="TESTBANK">TESTBANK</option>
                                    <option value="SPAY">SPAY</option> 
                                    <option value="PAYWIZE">PAYWIZE</option>
                                    <option value="BENACPAY">BENACPAY</option>
                                </select>
                                {errors.procName && <strong className="text-danger"><small>{errors.procName.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Processor Mid <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                {...register('procMid', { required : { value:true, message:"This field is required" } })} />
                                {errors.procMid && <strong className="text-danger"><small>{errors.procMid.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Paymode <strong className='text-danger'>*</strong></label>
                                <select className="form-select shadow-none" {...register('paymode', 
                                { required : { value:true, message:"This field is required" } })} >
                                    <option value="">--Select--</option>
                                    <option value="CARD">CARD</option> 
                                    <option value="IB">IB</option> 
                                    <option value="WALLET">WALLET</option> 
                                    <option value="UPI">UPI</option> 
                                    <option value="FT">FUND TRANSFER</option> 
                                </select>
                                {errors.paymode && <strong className="text-danger"><small>{errors.paymode.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Paymode Category <strong className='text-danger'>*</strong></label>
                                <select className="form-select shadow-none" {...register('paymodeCategory', 
                                { required : { value:true, message:"This field is required" } })} >
                                    <option value="">--Select--</option>
                                    <option value="UPII">UPII</option> 
                                    <option value="UPIC">UPIC</option>
                                    <option value="UPIOFFQR">UPIOFFQR</option>
                                    <option value="UPIONQR">UPIONQR</option>
                                    <option value="IMPS">IMPS</option>
                                    <option value="RTGS">RTGS</option>
                                    <option value="NEFT">NEFT</option>
                                </select>
                                {errors.paymodeCategory && <strong className="text-danger"><small>{errors.paymodeCategory.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Processor Credential 1 <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('procCred_1', { required : { value:true, message:"This field is required" } })} />
                                {errors.procCred_1 && <strong className="text-danger"><small>{errors.procCred_1.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Processor Credential 2 <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('procCred_2', { required : { value:true, message:"This field is required" } })} />
                                {errors.procCred_2 && <strong className="text-danger"><small>{errors.procCred_2.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Processor Credential 3 <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('procCred_3', { required : { value:true, message:"This field is required" } })} />
                                {errors.procCred_3 && <strong className="text-danger"><small>{errors.procCred_3.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Processor Credential 4 <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('procCred_4', { required : { value:true, message:"This field is required" } })} />
                                {errors.procCred_4 && <strong className="text-danger"><small>{errors.procCred_4.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Processor Credential 5 <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('procCred_5', { required : { value:true, message:"This field is required" } })} />
                                {errors.procCred_5 && <strong className="text-danger"><small>{errors.procCred_5.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Processor URL <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('procUrl', { required : { value:true, message:"This field is required" } })} />
                                {errors.procUrl && <strong className="text-danger"><small>{errors.procUrl.message}</small></strong>}
                            </div>
                            
                        </div>
                        <div className="text-center mt-3">
                            <button type="button" className="btn btn-secondary ms-2" data-bs-dismiss="modal" ref={closeRef}>CLOSE</button>
                            <button type="submit" className="btn _themebg-0 text-white ms-2">ADD</button>
                        </div>
                    </form>
                </div>
                </div>
            </div>
        </div>

    </>)
}